export const permissionsList = {
  MANAGE_LEAVE_REQUESTS: 'manage_leave_requests',
  MANAGE_GOALS: 'manage_goals',
  MANAGE_APPRAISALS: 'manage_appraisals',
  ADMINISTER_APPRAISALS: 'administer_appraisals'
};
